import {useState,useEffect} from 'react';
import Hero from '../components/Hero';
import { useLanguage } from '../i18n/LanguageContext';

import { useGenericEffect } from '../components/UseGenericEffect';
import TermsOfService from '../content/terms_of_service'; 
import PrivacyPolicy from '../content/privacy_policy';


export default function HowICanHelp() {
  const { strings } = useLanguage();

  

 

  return (
    <>
      <Hero title={strings.pages.terms_and_privacy.title} eyebrow={strings.pages.terms_and_privacy.eyebrow} />
      <main className="page-content">
          <div className="content-table max-centered">
              <div className="content-container">    
                  <div className="content-container-main show" id="content-container-main">
                  <h1>{strings.pages.terms_and_privacy.terms_title}</h1>
                  <br/>
                  <TermsOfService lang={strings.lang_code}/>
                  <h1>{strings.pages.terms_and_privacy.privacy_title}</h1>
                  <br/>
                  <PrivacyPolicy lang={strings.lang_code}/>
                  </div>       
              </div>
              <div class="hidden" id="loadstate">why_me</div>
       </div>
      </main>
    </>
  );
}